/* eslint-disable */
// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import React from 'react';
import { Row, Col, Form, Input, InputNumber, Select } from 'antd';
import propTypes from 'prop-types';

// USER COMPONENTS
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';
import CountryCodePicker from '../../../components/CountryCodePicker';

const EditReferral = ({ visible, onCancel, handleEdit, referral }) => {
  const [form] = Form.useForm();
  const handleSubmit = datas => {
    handleEdit(referral._id, {status: datas.status, remarks: datas.remarks});
    onCancel();
  };

  return Object.keys(referral).length > 0 ? (
    <Modal type={'primary'} title="Update Referral" visible={visible} footer={null} onCancel={onCancel} width={800}>
      <div className="query-modal" id="edit-customer-query-modal">
        <BasicFormWrapper>
          <Form
            form={form}
            name="basic"
            initialValues={{
              ...referral,
              code: referral?.phoneNumber.code,
              number: referral?.phoneNumber.number,
            }}
            onFinish={handleSubmit}
            autoComplete="off"
            layout="vertical"
          >
            {/* Full Name*/}
            <div className="add-product-block">
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="fullName"
                    label="Full Name"
                    rules={[{ required: true, message: 'Full name is required!' }]}
                  >
                    <Input placeholder="Full Name" disabled={true} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    style={{ flex: 3 }}
                    rules={[{ required: true, message: 'Email is required!' }]}
                  >
                    <Input type={'email'} placeholder="Email" disabled={true} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />

            {/* Phone number */}
            <div className="add-product-block">
              <Row gutter={[24, 16]}>
                <Col xs={24} md={8}>
                  <Form.Item
                    name="code"
                    label="Code"
                    rules={[{ required: true, message: 'Country code is required!' }]}
                  >
                    <CountryCodePicker form={form} container="edit-customer-query-modal" disabled={true} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={16}>
                  <Form.Item
                    name="number"
                    label="Phone Number"
                    style={{ flex: 3 }}
                    rules={[{ required: true, message: 'Phone number is required!' }]}
                  >
                    <InputNumber type={'number'} disabled={true} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />

            {/* Message*/}
            <div className="add-product-block">
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name="message"
                    label="Message"
                    rules={[
                      {
                        required: true,
                        message: 'message is required field!',
                      },
                    ]}
                  >
                    <Input placeholder="message......." disabled={true} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />
            
            {/* status */}
            <div className="add-product-block">
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name="status"
                    label="Status"
                    rules={[
                      {
                        required: true,
                        message: 'Please select status!',
                      },
                    ]}
                  >
                    <Select style={{ width: '100%' }} placeholder="Please select status">
                      <Select.Option value="pending">Pending</Select.Option>
                      <Select.Option value="in-review">In-Review</Select.Option>
                      <Select.Option value="approved">Approved</Select.Option>
                      <Select.Option value="rejected">Rejected</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />

            {/* Remarks*/}
            <div className="add-product-block">
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name="remarks"
                    label="Remarks"
                    rules={[
                      {
                        required: true,
                        message: 'remarks is required field!',
                      },
                    ]}
                  >
                    <Input placeholder="remarks......." />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />

            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button style={{ backgroundColor: '#155BDC', color: '#fff', marginRight: 5 }} htmlType="submit">
                  Update Referral Status
                </Button>
                <Button size="default" type="white" key="back" outlined onClick={onCancel}>
                  Cancel
                </Button>
              </div>
            </Form.Item>
          </Form>
        </BasicFormWrapper>
      </div>
    </Modal>
  ) : null;
};

EditReferral.propTypes = {
  visible: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
};

export default EditReferral;
